import classNames from "classnames"
import PropTypes from "prop-types"
import "./style.scss"

function Card({ children, title, rightOptions, leftOptions, subHeader, fixed, className, noHeader, noSubHeaderPadding }) {
  return <div className={classNames("components_card", className, { fixed })}>
    {!noHeader && <div className="header">
      <div className="left">
        <div className="title">{title}</div>
        {leftOptions}
      </div>
      {rightOptions && <div className="options">
        {rightOptions}
      </div>}
    </div>}
    {subHeader && <div className={classNames("sub-header", { "no-padding": noSubHeaderPadding })}>
      {subHeader}
    </div>}
    {children}
  </div>
}

Card.propTypes = {
  title: PropTypes.node,
  leftOptions: PropTypes.element,
  rightOptions: PropTypes.element,
  subHeader: PropTypes.element,
  fixed: PropTypes.bool,
  noHeader: PropTypes.bool,
  noSubHeaderPadding: PropTypes.bool,
  className: PropTypes.string,
}

export default Card
